var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7844_928",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 128
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.0293,
    cy: 64,
    r: 64,
    fill: "#D0D4D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7844_928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.0293,
    cy: 64,
    r: 64,
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7418 38C83.3476 38 85.46 40.1124 85.46 42.7182V78.5497C85.46 81.1554 83.3476 83.2678 80.7418 83.2678H51.6079C50.587 83.2678 49.5937 83.5989 48.777 84.2115L38.2306 92.1212C36.2411 93.6134 33.402 92.1938 33.402 89.707V87.986C33.402 85.3802 31.2896 83.2678 28.6838 83.2678H24.5398C21.934 83.2678 19.8216 81.1554 19.8216 78.5497V42.7182C19.8216 40.1124 21.934 38 24.5398 38H80.7418Z",
    fill: "#4D5659"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4211 84.9131H94.5283V92.4578C94.5283 94.9446 91.6892 96.3642 89.6997 94.8721L76.4211 84.9131Z",
    fill: "#FFC220"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7844_928)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4342 45.6808C43.8285 45.6808 41.7161 47.7932 41.7161 50.3989V86.2304C41.7161 88.8362 43.8285 90.9486 46.4342 90.9486H80.6337C81.6546 90.9486 82.6479 91.2797 83.4646 91.8922L93.4723 99.398C95.4618 100.89 98.3009 99.4706 98.3009 96.9837V95.6668C98.3009 93.061 100.413 90.9486 103.019 90.9486H103.391C105.996 90.9486 108.109 88.8362 108.109 86.2304V50.3989C108.109 47.7932 105.996 45.6808 103.391 45.6808H46.4342Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4342 45.6808C43.8285 45.6808 41.7161 47.7932 41.7161 50.3989V86.2304C41.7161 88.8362 43.8285 90.9486 46.4342 90.9486H80.6337C81.6546 90.9486 82.6479 91.2797 83.4646 91.8922L93.4723 99.398C95.4618 100.89 98.3009 99.4706 98.3009 96.9837V95.6668C98.3009 93.061 100.413 90.9486 103.019 90.9486H103.391C105.996 90.9486 108.109 88.8362 108.109 86.2304V50.3989C108.109 47.7932 105.996 45.6808 103.391 45.6808H46.4342Z",
    fill: "url(#paint0_linear_7844_928)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.0293,
    y: 77.4999,
    width: 54,
    height: 6,
    rx: 1.5,
    fill: "#D0D4D9",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.0293,
    y: 53.4999,
    width: 35,
    height: 6,
    rx: 1.5,
    fill: "#4D5659"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.0293,
    y: 65.4999,
    width: 54,
    height: 6,
    rx: 1.5,
    fill: "#D0D4D9",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7844_928",
    x: 24.0229,
    y: 29.0934,
    width: 101.779,
    height: 89.7127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10582
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.84659
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7844_928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7844_928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7844_928",
    x1: 74.9125,
    y1: 45.6808,
    x2: 74.9125,
    y2: 100.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.ae40447dd9a2e028269fab542a0c27a4.svg";
export { ForwardRef as ReactComponent };